import React, { useState, useEffect } from "react";
import * as PrimeDataTable from "primereact/datatable";
import {
  Alert,
  Button,
  Col,
  FormGroup,
  Label,
  Nav,
  Row,
  NavItem,
  NavLink,
  Spinner,
} from "reactstrap";

import { Column } from "primereact/column";
import { ColumnGroup } from "primereact/columngroup";
import { Dropdown } from "primereact/dropdown";
import { Ripple } from "primereact/ripple";
import { classNames } from "primereact/utils";

import { useSelector } from "react-redux";
import axios from "axios";
import { useCookies } from "react-cookie";
import config from "../../config";

import classnames from "classnames";
import Flatpickr from "react-flatpickr";
import InputSelectCustom from "../../components/Common/InputSelectCustom";
import SimpleBarFilterCustom from "../../components/Common/SimpleBarFilterCustom";


const TableDrillDownCustom = ({
  paginator = true,
  Nivel = 0,
  ID_Consulta = 0,
  paddingLeft = 10,

  hasFilter = true,
  isExpanded = false,
  paginatorSubItems = false,
  changeKeysReference,
  customParams, 
  filterParams,

  revendaOptions,
  fornecedorOptions
}) => {
  const { userProfile } = useSelector((state) => ({
    userProfile: state.login.user,
  }));

  const [isLoading, setIsLoading] = useState(false);
  const [productList, setProductList] = useState([]);
  const [columnsList, setColumnsList] = useState([]);
  const [resultset2, setResultset2] = useState();
  const [totalRecords, setTotalRecords] = useState();

  const [customParamsState, setcustomParamsState] = useState(customParams)
  const [filterParamsState, setfilterParamsState] = useState(filterParams)

  const [cookies] = useCookies(["_csrf_token"]);
  const [dataKey, setDataKey] = useState("Codigo_Produto_Revenda");
  const [idConsulta, setIdConsulta] = useState(ID_Consulta);
  const [messageError, setMessageError] = useState(null);
  const [expandedRows, setExpandedRows] = useState({});

  const [isOpenModal, setIsOpenModal] = useState(false);

  // Após uma coluna ser expandida, esta função renderizará o conteúdo
  const rowExpansionTemplate = (data) => {
    return (
      <TableDrillDownCustom
        paginator={paginatorSubItems}
        key={Nivel + 1}
        paddingLeft={paddingLeft + 10}
        Nivel={Nivel + 1}

        changeKeysReference={changeKeysReference}
        filterParams={filterParamsState}
        customParams={customParamsState}
      />
    );
  };

  //(não remover) - essa função é usada quando o backend retornar informações das colunas
  const genericComponent = (rowData, field, expander = false) => {
    let fieldName = rowData[field];
    return (
      <div className="d-flex gap-2 align-items-center">
        {expander && rowData.isExpanded == "S" && (
          <button
            onClick={() => expandItem(rowData, field)}
            type="button"
            className="btn p-0 m-0 d-flex align-items-center"
          >
            <i
              className={`font-size-20 text-secondary fas fa-caret-${
                expandedRows[rowData[field]] ? "down" : "right"
              }`}
            ></i>
          </button>
        )}
        <span>{fieldName}</span>
      </div>
    );
  };

  // Função customiza - responsável por identificar o evento de expansão da coluna
  const expandItem = (rowData, field) => {
    let _expandedRows = {};
    setcustomParamsState(state => ({...state, [changeKeysReference[field]]: rowData[changeKeysReference[field]]}))
    setDataKey(field);

    productList.forEach((p) =>
      rowData[field] == p[field]
        ? (_expandedRows[p[field]] = expandedRows[p[field]] ? false : true)
        : (_expandedRows[p[field]] = false)
    );

    setExpandedRows(
      Object.keys(_expandedRows)
        .filter((key) => _expandedRows[key])
        .reduce((res, key) => ((res[key] = _expandedRows[key]), res), {})
    );
  };

  // Responsável por buscar os dados no backend
  const handleDataOnExpandedRow = (updateFilterParamsState = filterParamsState) => {
    setIsLoading(true);
    setMessageError(null);
    axios
      .post(
        `${config.URL_SERVER}/execute-procedure`,
        {
          proc: "VENDA_SEGURA_Obter_Dados_Sellout",
          requestData: {
            1: userProfile?.resultset_2[0].ID_Usuario || 0, //ID_Usuario
            2: idConsulta, // ID_Consulta
            3: updateFilterParamsState?.RevendaFilter?.value || null, //Filter_Empresa_Revenda
            4: updateFilterParamsState?.LojaFilter?.value || null, //Filter_Empresa_Revenda
            5: updateFilterParamsState?.FornecedorFilter?.value || null, // ID_Empresa_Parceiro
            6: updateFilterParamsState.DataInicioFilter, //Data_Inicial	(datetime)
            7: updateFilterParamsState.DataFinalFilter, //Data_Final (datetime)
            8: updateFilterParamsState?.VisaoFilter, //visao
            9: Nivel, //Nivel
            10: customParamsState.Codigo_Produto_Revenda, //Param_Codigo_Produto_Revenda
            11: customParamsState.Ano, //Param_Ano
            12: customParamsState.Mes, //Param_Mes
            13: customParamsState.ID_Empresa, //Param_ID_Empresa_Revenda
            14: customParamsState.ID_Empresa_Parceiro, //Param_ID_Empresa_Parceiro
            15: customParamsState.UF, //Param_UF
            16: customParamsState.ID_Zona, //Param_Zona
            17: customParamsState.ID_Planta, //Param_ID_Planta
            18: customParamsState.ID_Cidade, //Param_ID_Planta
            19: customParamsState.ID_Loja, //Param_ID_Planta
          },
        },
        {
          headers: {
            "X-CSRF-Token": cookies._csrf_token,
          },
        }
      )
      .then(({ data }) => {
        setMessageError(null);
        if (data?.resultset_2 && data?.resultset_1) {
          setProductList(
            data.resultset_1.map((i) => {
              i.isExpanded = data.resultset_2[0]?.isExpanded;
              return i;
            })
          );
          setColumnsList(JSON.parse(data.resultset_2[0]?.Tabela_Colunas));
          setResultset2(data.resultset_2[0]);
          if (data?.resultset_2[0].Total_Registros && paginator)
            setTotalRecords(data?.resultset_2[0]?.Total_Registros);
          if (data?.resultset_2[0].ID_Consulta)
            setIdConsulta(data?.resultset_2[0]?.ID_Consulta);
        }
      })
      .catch((e) => {
        console.log("Erro ao se comunicar com o Backend", e);
        setMessageError("Erro ao se comunicar com o Backend");
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const footerGroup = (
    <ColumnGroup>
      <Row>
        {columnsList.map((col, i) => (
          <Column key={i} footer={col?.footer} />
        ))}
      </Row>
    </ColumnGroup>
  );

  const paginatorLeft = (props) => {
    return (
      <div className="d-flex container-left-paginator align-items-center p-0 m-0 gap-4">
        <div
          style={{ width: 150 }}
          className="font-size-12 text-black bg-light_gray_05 p-3 rounded-start-4 text-center"
        >
          <span className="text-primary fw-bold">Totalizadores</span>
        </div>
        <div className="col">
          <div className="d-flex align-items-center gap-3">
            <div className="font-size-12 text-black">
              Total teste 1:{" "}
              <span className="text-primary fw-bold">R$ 200.000,22</span>
            </div>
            <div className="font-size-12 text-black">
              Total teste 1:{" "}
              <span className="text-primary fw-bold">R$ 200.000,22</span>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const paginatorTemplate = {
    layout: "RowsPerPageDropdown PrevPageLink PageLinks NextPageLink",
    PageLinks: (options) => {
      if (
        (options.view.startPage === options.page &&
          options.view.startPage !== 0) ||
        (options.view.endPage === options.page &&
          options.page + 1 !== options.totalPages)
      ) {
        const className = classNames(
          options.className,
          { "p-disabled": true },
          "rounded-0 m-0"
        );
        return <span className={className}> ... </span>;
      }

      return (
        <button
          type="button"
          className={options.className}
          onClick={options.onClick}
        >
          {options.page + 1}
          <Ripple />
        </button>
      );
    },
    RowsPerPageDropdown: (options) => {
      const dropdownOptions = [
        { label: 10, value: 10 },
        { label: 20, value: 20 },
        { label: 30, value: 30 },
        { label: "All", value: options.totalRecords },
      ];

      return (
        <div className="p-0 m-0 d-flex align-items-center gap-2">
          <span className="font-size-14 text-black">Resultados por página</span>
          <Dropdown
            className="mx-2"
            value={options.value}
            options={dropdownOptions}
            onChange={options.onChange}
          />
        </div>
      );
    },
  };

  const ComboboxRevenda = () => {
    const loadOptions = (inputValue, callback) => {
      if (inputValue) {
        const filteredOptions = revendaOptions.filter((option) =>
          option.label.toLowerCase().includes(inputValue.toLowerCase())
        );
        callback(filteredOptions);
      } else {
        callback(revendaOptions);
      }
    };

    return (
      <InputSelectCustom
        name={"Revenda"}
        stateSelected={filterParamsState.RevendaFilter}
        optionsData={revendaOptions}
        placeholder="Todos"
        loadOptions={loadOptions}
        handleOnChange={(selected) => {
          setfilterParamsState(state => ({...state, RevendaFilter: selected, LojaFilter: null}));
        }}
      />
    );
  };

  const ComboboxLoja = () => {
    const [displayedOptions, setDisplayedOptions] = useState([]);

    const getData = async () => {
      try {
        const { data } = await axios.post(
          `${config.URL_SERVER}/execute-procedure`,
          {
            proc: "FRONT_Usuario_Obter_Plantas_Origem_DecPerm",
            requestData: {
              1: filterParamsState?.RevendaFilter?.value || null,
              2: "A",
              3: userProfile?.resultset_2[0].ID_Usuario || 0,
              4: "PED",
            },
          },
          {
            headers: {
              "X-CSRF-Token": cookies._csrf_token,
            },
          }
        );
        if (data.length) {
          const empresasOptions = data.map((item) => ({
            value: item.ID_Planta,
            label: item.Descricao,
          }));
          setDisplayedOptions(empresasOptions);
        }
      } catch (error) {
        console.log("Erro ao buscar dados [ComboboxRevenda] :", error);
      }
    };

    const loadOptions = (inputValue, callback) => {
      if (inputValue) {
        const filteredOptions = displayedOptions.filter((option) =>
          option.label.toLowerCase().includes(inputValue.toLowerCase())
        );
        callback(filteredOptions);
      } else {
        callback(displayedOptions);
      }
    };

    useEffect(() => {
      if(filterParamsState.RevendaFilter) getData();
    }, [filterParamsState.RevendaFilter]);

    return (
      <div>
        <InputSelectCustom
          name={"Loja"}
          stateSelected={filterParamsState.LojaFilter}
          optionsData={displayedOptions}
          placeholder="Todos"
          isDisabled={filterParamsState.RevendaFilter === null}
          loadOptions={loadOptions}
          handleOnChange={(selected) => {
            setfilterParamsState(state => ({...state, LojaFilter: selected}));
          }}
        />
      </div>
    );
  };

  const ComboboxFornecedor = () => {
    const loadOptions = (inputValue, callback) => {
      if (inputValue) {
        const filteredOptions = fornecedorOptions.filter((option) =>
          option.label.toLowerCase().includes(inputValue.toLowerCase())
        );
        callback(filteredOptions);
      } else {
        callback(fornecedorOptions);
      }
    };

    return (
      <InputSelectCustom
        name={"Fornecedor"}
        stateSelected={filterParamsState.FornecedorFilter}
        optionsData={fornecedorOptions}
        placeholder="Todos"
        loadOptions={loadOptions}
        handleOnChange={(selected) => {
          setfilterParamsState(state => ({...state, FornecedorFilter: selected}));
        }}
      />
    );
  };

  const onSubmitFilter = () => {
    setIsOpenModal(false);
    handleDataOnExpandedRow();
  };

  const onClearFilter = () => {
    setfilterParamsState(state => ({...state, RevendaFilter: null, LojaFilter: null, FornecedorFilter: null}))
    setIsOpenModal(false);
    handleDataOnExpandedRow({...filterParamsState, RevendaFilter: null, LojaFilter: null, FornecedorFilter: null});
  };

  const hasFilterSelected = () => {
    return filterParamsState.RevendaFilter || filterParamsState.FornecedorFilter || filterParamsState.DataFinalFilter || filterParamsState.DataInicioFilter;
  };

  const onChangePreFilter = (value) => {
    if(value !== filterParamsState.VisaoFilter){
      setfilterParamsState(state => ({...state, VisaoFilter: value}))
      handleDataOnExpandedRow({...filterParamsState, VisaoFilter: value});
    }
  }

  useEffect(() => {
    handleDataOnExpandedRow()
  }, []);

  return (
    <div>
      {Nivel == 0 && (
        <>
          <SimpleBarFilterCustom
            isOpen={isOpenModal}
            onClose={setIsOpenModal}
            onSubmit={onSubmitFilter}
            onClearFilter={onClearFilter}
            disabledClearFilter={!hasFilterSelected()}
          >
            <Row className="m-0 mb-1 form-custom01-filter">
              <Col md={12} className="p-0">
                <FormGroup>
                  <Label for="Empresa">Revenda</Label>
                  <ComboboxRevenda />
                </FormGroup>
              </Col>
              <Col md={12} className="p-0">
                <FormGroup>
                  <Label for="Loja">Loja</Label>
                  <ComboboxLoja />
                </FormGroup>
              </Col>
              <Col md={12} className="p-0">
                <FormGroup>
                  <Label for="Fornecedor">Fornecedor</Label>
                  <ComboboxFornecedor />
                </FormGroup>
              </Col>
              <Col md={12} className="p-0">
                <Label for="Data Início">Data Início</Label>
                <FormGroup>
                  <Flatpickr
                    className="form-control d-block"
                    onChange={(d) =>
                      setfilterParamsState(state => ({...state, DataInicioFilter: new Date(d).toLocaleDateString()}))
                    }
                    placeholder="dd-mm-aaaa"
                    options={{
                      locale: "pt",
                      altInput: true,
                      altFormat: "d/m/Y",
                      dateFormat: "Y-m-d",
                      defaultDate: filterParamsState.DataInicioFilter
                    }}
                  />
                  <i className="position-absolute end-0 top-50 mx-3 fas fa-calendar-alt"></i>
                </FormGroup>
              </Col>
              <Col md={12} className="p-0">
                <Label for="Data Final">Data Final</Label>
                <FormGroup>
                  <Flatpickr
                    className="form-control d-block"
                    onChange={(d) =>
                      setfilterParamsState(state => ({...state, DataFinalFilter: new Date(d).toLocaleDateString()}))
                    }
                    placeholder="dd-mm-aaaa"
                    options={{
                      locale: "pt",
                      altInput: true,
                      altFormat: "d/m/Y",
                      dateFormat: "Y-m-d",
                      defaultDate: filterParamsState.DataFinalFilter
                    }}
                  />
                  <i className="position-absolute end-0 top-50 mx-3 fas fa-calendar-alt"></i>
                </FormGroup>
              </Col>
            </Row>
          </SimpleBarFilterCustom>
          <Row>
            <Col
              lg={12}
              className={`mb-3 nav-accordion-custom ${
                isLoading ? "disabled" : ""
              }`}
            >
              <Row className="d-flex align-items-center justify-content-between pb-3">
                <Col lg={6}>
                  <Nav tabs>
                    <NavItem>
                      <NavLink
                        disabled={isLoading}
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: filterParamsState.VisaoFilter === "LOJA",
                        })}
                        onClick={() => onChangePreFilter("LOJA")}
                      >
                        Por Loja
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        disabled={isLoading}
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: filterParamsState.VisaoFilter === "SKU",
                        })}
                        onClick={() => onChangePreFilter("SKU")}
                      >
                        Por SKU
                      </NavLink>
                    </NavItem>
                  </Nav>
                </Col>
                <Col lg={6} className="d-flex justify-content-end gap-3">
                  <Button
                    className="button-filter-action"
                    onClick={() => setIsOpenModal(!isOpenModal)}
                  >
                    Filtros
                  </Button>
                </Col>
              </Row>

              {hasFilterSelected() && (
                <Row>
                  <Col lg={12} className="d-flex gap-2 align-items-center">
                    <button className="btn px-0 border-0 text-black font-size-12">
                      Filtros aplicados:
                    </button>
                    {filterParamsState?.RevendaFilter?.label && (
                      <button
                        onClick={() => {
                          setfilterParamsState(state => ({...state, RevendaFilter: null}))
                          handleDataOnExpandedRow()
                        }}
                        className="btn btn-primary font-size-12 px-3 rounded-pill d-flex align-items-center gap-3"
                      >
                        Revenda: {filterParamsState?.RevendaFilter?.label}
                        <i className="fas fa-times font-white"></i>
                      </button>
                    )}
                    {filterParamsState?.LojaFilter?.label && (
                      <button
                        onClick={() => {
                          setfilterParamsState(state => ({...state, LojaFilter: null}))
                          handleDataOnExpandedRow()
                        }}
                        className="btn btn-primary font-size-12 px-3 rounded-pill d-flex align-items-center gap-3"
                      >
                        Loja: {filterParamsState?.LojaFilter?.label}
                        <i className="fas fa-times font-black"></i>
                      </button>
                    )}
                    {filterParamsState?.FornecedorFilter?.label && (
                      <button
                        onClick={() => {
                          setfilterParamsState(state => ({...state, FornecedorFilter: null}))
                          handleDataOnExpandedRow()
                        }}
                        className="btn btn-primary font-size-12 px-3 rounded-pill d-flex align-items-center gap-3"
                      >
                        Fornecedor: {filterParamsState?.FornecedorFilter?.label}
                        <i className="fas fa-times font-white"></i>
                      </button>
                    )}
                    {filterParamsState.DataInicioFilter && (
                      <button
                        // onClick={() => {
                        //   setDataInicio(null)
                        //   handleDataOnExpandedRow()
                        // }}
                        className="btn btn-primary font-size-12 px-3 rounded-pill d-flex align-items-center gap-3"
                      >
                        Data Início: {filterParamsState.DataInicioFilter}
                        {/* <i className="fas fa-times font-white"></i> */}
                      </button>
                    )}
                    {filterParamsState.DataFinalFilter && (
                      <button
                        // onClick={() => {
                        //   setDataFinal(null)
                        //   handleDataOnExpandedRow()
                        // }}
                        className="btn btn-primary font-size-12 px-3 rounded-pill d-flex align-items-center gap-3"
                      >
                        Data Final: {filterParamsState.DataFinalFilter}
                        {/* <i className="fas fa-times font-white"></i> */}
                      </button>
                    )}
                  </Col>
                </Row>
              )}
            </Col>
          </Row>
        </>
      )}

      {messageError && (
        <div className="w-100 d-flex align-items-center justify-content-center p-1">
          <Alert className="w-100" color="warning">
            <p className="m-0 p-0">{messageError}</p>
          </Alert>
        </div>
      )}

      <PrimeDataTable.DataTable
        tableClassName="table mb-0 table-light font-size-14 table-sm"
        value={productList}
        paginatorTemplate={paginatorTemplate}
        sortMode="single"
        groupRowsBy={dataKey}
        rowGroupMode="rowspan"
        expandedRows={expandedRows}
        onRowToggle={(e) => setExpandedRows(e.data)}
        rowExpansionTemplate={rowExpansionTemplate}
        dataKey={dataKey}
        loading={isLoading}
        emptyMessage={"Nenhum registro encontrado."}
        loadingIcon={<Spinner className="text-primary" size="sm" />}
        reorderableColumns
        paginatorClassName="paginator-table-custom pt-3 pb-3 px-0"
        paginatorLeft={paginatorLeft}
        footerColumnGroup={resultset2?.isFooter == "S" ? footerGroup : <></>}
        pageLinkSize={6}
        totalRecords={totalRecords}
        paginator={paginator}
        rows={10}
      >
        {columnsList.map((col, i) => (
          <Column
            style={{ paddingLeft: i === 0 ? paddingLeft : 10 }}
            key={col.field}
            sortable
            headerStyle={{
              background: resultset2?.bgColor ? resultset2?.bgColor : "",
              width: col?.width ? col.width : "auto",
            }}
            bodyStyle={{
              padding: `0 10px 0 ${paddingLeft}`,
            }}
            field={col.field}
            body={eval(col.body)}
            header={col.header}
          />
        ))}
      </PrimeDataTable.DataTable>
    </div>
  );
};

export { TableDrillDownCustom };
